import React from 'react';
import { Popup as Modal } from 'reactjs-popup';
import ServiceRequestAssignForm from '../../../../ServiceRequest/ServiceRequestAssignForm';
import { updateBulkStatus } from '../../../../../services/client';
import { selectAuthenticatedUser } from '../../../../../store/selectors/auth';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

export const AssignedStatusOverlay = ({
  serviceRequests,
  showAssignedStatusOverlay,
  setShowAssignedStatusOverlay,
  fetchDashboard,
}) => {
  const serviceRequestIds = serviceRequests.map((sr) => ({ id: sr.id }));
  const user = useSelector(selectAuthenticatedUser);

  const handleStatusChange = (data) => {
    updateBulkStatus({
      serviceRequest: serviceRequestIds,
      name: 'Assigned',
      userId: user.id,
      ServiceProviderId: data.userId,
    }).then((res) => {
      console.log(res);
      if (res.status === 200) {
        toast.success('Service requests updated successfully', {
          autoClose: 5000,
          position: 'top-center',
        });
        fetchDashboard();
      } else {
        toast.error(
          '🚫 Failed to update service requests, please try again later.',
          { autoClose: 5000, position: 'top-center' }
        );
      }
    });
    setShowAssignedStatusOverlay(false);
  };
  return (
    <>
      <Modal
        open={showAssignedStatusOverlay}
        onClose={() => setShowAssignedStatusOverlay(false)}
        closeOnDocumentClick={true}
        className="popup-wide"
        contentStyle={{ width: '80% !important' }}
      >
        <ServiceRequestAssignForm
          from="dashboard"
          serviceRequest={{
            ...serviceRequests[0],
            serviceType: serviceRequests[0]?.type,
            ticketId: serviceRequests[0]?.ticketNumber,
          }}
          onClose={() => setShowAssignedStatusOverlay(false)}
          handleStatusChange={(data) => handleStatusChange(data)}
          isLegacyTable={false}
        />
      </Modal>
    </>
  );
};
